import React from 'react';
import LottieAnimation from '@/v2/components/behaviours/LottieAnimation';
import Icon from '@/v2/components/atoms/Icon';
import animationData from './LottieScrollSwipe.json';

const ScrollSwipe = (props) => (
    <Icon iconName="ScrollSwipe" {...props}>
        <LottieAnimation animationData={animationData} />
    </Icon>
);

export default ScrollSwipe;
